module.exports = __webpack_public_path__ + "static/Gotham-ExtraLightItalic-8fbbc9ba571ae74ef3cba27adb46830b.woff";